<script setup>
import { User } from "lucide-vue-next"
defineProps({ src: String, alt: String, size: { type: Number, default: 36 }, fallback: String })
</script>

<template>
  <span
    class="inline-flex items-center justify-center overflow-hidden rounded-full border bg-muted"
    :style="{ width: `${size}px`, height: `${size}px` }"
  >
    <img v-if="src" :src="src" :alt="alt" class="h-full w-full object-cover" />
    <span v-else class="text-xs text-muted-foreground">
      <span v-if="fallback">{{ fallback }}</span>
      <User v-else class="h-4 w-4 opacity-70" />
    </span>
  </span>
</template>
